export default function safeLoad(body) {
	return JSON.parse(body);
}